<template>
 <div>
  <div class="row">
    <div class="col-md-6 col-md-border mb-3">
      <div class="mb-5">
        <div class="lyon-display-medium-24 mb-2">Colloquia & Seminars</div>
        <div v-if="loading">
          <generic-loader />
        </div>
        <div v-else-if="seminarList.length === 0">
          <span class="text-muted regular-14">No result</span>
        </div>
        <div v-else>
          <div class="main-content">
            <div v-for="(item, index) in seminarList" :key="index">
              <div @click="fetchSelectedEvent(item.id, 'seminar-tab-grid-dtl-id', 'seminars')" class="cursor-pointer">
                <left-grid-event-list
                  :event-item="item"
                  :active-item-id="activeItemId"
                />
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center flex-shrink-0 mt-3">
            <b-pagination
              pills
              :total-rows="pagination.total_rows"
              v-model="currentPage"
              @input="filteredList()"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-md-border right-side-program-section" id="seminar-tab-grid-dtl-id">
      <b-card class="sticky-content" v-if="showDetails">
        <right-grid-event-detail
          :selected-event="selectedEvent"
          :active-item-id="activeItemId"
          :button-name="'VIEW DETAILS'"
          :page-name="'colloquia-seminars-details'"
        />
      </b-card>
    </div>
  </div>
 </div>
</template>

<script>
import mixin from '@/utils/mixin.js'
import LeftGridEventList from '@/components/CommonPages/LeftGridEventList.vue'
import RightGridEventDetail from '@/components/CommonPages/RightGridEventDetail.vue'
import GenericLoader from '@/components/Loaders/GenericLoader.vue'
import debounce from 'lodash/debounce'

export default {
  name: 'ColloquiaAndSeminarsTabSection',
  components: { LeftGridEventList, RightGridEventDetail, GenericLoader },
  mixins: [mixin],
  data () {
    return {
      search: '',
      selectedEvent: {},
      showDetails: false,
      activeItemId: '',
      loading: true,
      currentPage: 1,
      pagination: {},
      seminarList: []
    }
  },
  mounted() {
    this.loadSeminar()
  },
  methods: {
    loadSeminar () {
      this.showDetails = false
      this.$http.get(process.env.VUE_APP_API_URL + `/programs/${this.$route.params.id}/seminars`, {
        params: {
          page: this.currentPage,
        }
      })
      .then((res) => {
        this.seminarList = res.data.seminars
        this.pagination = res.data.pagination
        this.loading = false
      })
    },
    filteredList: debounce(function() {
      this.showDetails = false
      this.loading = true
      scrollToElementId('seminar-tab-grid-dtl-id')
      this.$http.get(process.env.VUE_APP_API_URL + `/programs/${this.$route.params.id}/seminars`, {
      params: {
        page: this.currentPage,
      }
      })
      .then((res) => {
        this.seminarList = res.data.seminars
        this.pagination = res.data.pagination
        this.loading = false
      })
    }, 800)
  }
}
</script>
